import { useState } from 'react'
import NotificationsIcon from '@mui/icons-material/Notifications'
import { Stack, Tooltip } from '@mui/material'
import Badge from '@mui/material/Badge'
import Popover from '@mui/material/Popover'

import Notifications from '@/Components/Common/Notifications'
import { usePage } from '@/Components/Pages/PageProvider'

const NotificationsMenu = () => {
  const { currentUser } = usePage()
  const {
    notifications: { unreadCount = 0 }
  } = currentUser || {}
  const [notificationsAnchorEl, setNotificationsAnchorEl] =
    useState<null | HTMLElement>(null)
  const isNotificationsOpen = Boolean(notificationsAnchorEl)
  const handleNotificationsClick = (event: React.MouseEvent<HTMLElement>) => {
    setNotificationsAnchorEl(event.currentTarget)
  }
  const handleNotificationsClose = () => {
    setNotificationsAnchorEl(null)
  }
  return (
    <Stack alignItems="center" justifyContent="center">
      {unreadCount > 0 && (
        <Badge
          color="success"
          variant="dot"
          overlap="circular"
          sx={{ cursor: 'pointer' }}
          onClick={handleNotificationsClick}
          id="notifications-button"
        >
          <NotificationsIcon color="action" sx={{ fontSize: 26 }} />
        </Badge>
      )}
      {!unreadCount && (
        <Tooltip title="No new notifications" arrow>
          <NotificationsIcon
            sx={{ fontSize: 26, color: '#CCC' }}
            id="no-notifications-icon"
          />
        </Tooltip>
      )}
      <Popover
        open={isNotificationsOpen}
        anchorEl={notificationsAnchorEl}
        onClose={handleNotificationsClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Notifications />
      </Popover>
    </Stack>
  )
}

export default NotificationsMenu
